/**
 * Registry → Images tab. Build output of the feature registry.
 */

import type { ReactElement } from 'react';
import { ImageCacheTable } from '@features/devcontainer/components/admin/ImageCacheTable';

export function ImagesTab(): ReactElement {
  return <ImageCacheTable />;
}
